import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ProjectContext } from './ProjectContext';
import Sidebar from './Sidebar';
import CreateProject from './CreateProject';
import ReadProjects from './ReadProjects';
import UpdateProject from './UpdateProject';
import DeleteProject from './DeleteProject';
import Home from './Home';
import Timeline from './Timeline';

const Dashboard = () => {
  const { user } = useContext(ProjectContext);
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState('home'); // Default to 'home'
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  if (!user) {
    navigate('/login');
    return (
      <p className="text-center text-gray-700 my-20 font-extralight text-3xl">
        Please <Link to="/login" className="underline font-semibold">log in</Link> to access the dashboard.
      </p>
    );
  }

  const renderContent = () => {
    switch (currentView) {
      case 'home':
        return <Home />;
      case 'timeline':
        return <Timeline />;
      case 'create':
        return <CreateProject setCurrentView={setCurrentView} />;
      case 'read':
        return <ReadProjects setCurrentView={setCurrentView} />;
      case 'update':
        return <UpdateProject setCurrentView={setCurrentView} />;
      case 'delete':
        return <DeleteProject setCurrentView={setCurrentView} />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="flex">
        <Sidebar
          setCurrentView={setCurrentView}
          currentView={currentView}
          setIsSidebarExpanded={setIsSidebarExpanded}
        />
        <div
          className={`flex-1 pt-36 pb-20 px-4 sm:px-6 lg:px-8 transition-all duration-300
            ${isSidebarExpanded ? 'md:ml-64' : 'md:ml-16'}
          `}
        >
          <div className="max-w-7xl mx-auto">
            <div className="p-3">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default Dashboard;